import React from 'react'
import { localizeDataQualityTypeName } from '../dataQualityWarnings/DataQualityType';
import { IndicatorGroupHeadingDiv, IndicatorAssetGroupDiv, IndicatorIndicatorsGroupDiv, CertificationIconWrapperStyle, IndicatorAssetChildGroupDiv } from '../style/DataQualityIndicatorStyles';
import { DataQualityCertificationNonInteractiveIcon, DataQualityWarningNonInteractiveButton } from './DataQualityIndicatorButtons';
import { onThisAssetMessage, upstreamOfThisAssetMessage } from './DataQualityIndicatorFragments';
import { DataQualityDetailAuthorElement, DataQualityDetailAsset, DataQualityDetailChipId, DataQualityDetailDateElement, DataQualityDetailMessageElement, RenderIndicatorAssetProps, RenderIndicatorsProps } from './DataQualityIndicatorSharedHelpers';

function BigSpacer(): JSX.Element {
  return (<hr style={{
    borderColor: '#E6E6E6'
  }} />);
}

function RenderIndicators(props: Required<Pick<RenderIndicatorAssetProps, 'assetName' | 'indicators' | 'linksDisabled'>> & { readonly keyIndex?: string; }): JSX.Element {
  return (
    <React.Fragment key={props.keyIndex}>
      {
        props.indicators.map((i, index) =>
          <React.Fragment key={index}>
            {
              i.kind === 'certification' ?
                <span style={{ display: 'flex', }}>
                  <CertificationIconWrapperStyle>
                    <DataQualityCertificationNonInteractiveIcon />
                  </CertificationIconWrapperStyle>
                  <DataQualityDetailAuthorElement {...i} linksDisabled={props.linksDisabled ?? false} />
                </span>
                :
                <>
                  <DataQualityWarningNonInteractiveButton
                    testId={DataQualityDetailChipId}
                    title={localizeDataQualityTypeName(i.type)}
                    warningKind={i.kind}
                  />
                  <DataQualityDetailAuthorElement {...i} linksDisabled={props.linksDisabled ?? false} />
                </>
            }
            <DataQualityDetailDateElement {...i} />
            <DataQualityDetailMessageElement {...i} assetName={props.assetName} />
          </React.Fragment>
        )
      }
    </React.Fragment>
  )
}

function RenderAnchoredAssetsIndicators(props: RenderIndicatorsProps): JSX.Element | null {
  if (props.indicators.length < 1 && props.childrenIndicatorAndAsset.length < 1) {
    return null;
  }

  return (
    <>
      <IndicatorGroupHeadingDiv>
        {onThisAssetMessage(props.assetType)}
      </IndicatorGroupHeadingDiv>
      <IndicatorAssetGroupDiv>
        <DataQualityDetailAsset
          assetName={props.assetName}
          assetType={props.assetType}
          assetUrl={props.linksDisabled ? null : props.assetUrl}
          remoteType={props.remoteType}
        />
        <IndicatorIndicatorsGroupDiv>
          <RenderIndicators linksDisabled={props.linksDisabled ?? false} assetName={props.assetName} indicators={props.indicators} />
        </IndicatorIndicatorsGroupDiv>
        <RenderChildIndicators {...props} />
      </IndicatorAssetGroupDiv>
    </>
  )
}

function RenderChildIndicators({ childrenIndicatorAndAsset, linksDisabled }: RenderIndicatorsProps): JSX.Element | null {
  if (childrenIndicatorAndAsset.length < 1) {
    return null;
  }

  const ordered = [...childrenIndicatorAndAsset].sort(asset => asset.indicators.some(i => i.kind === 'severe-warning') ? -1 : 1);

  return (
    <IndicatorAssetChildGroupDiv>
      {
        ordered.map((c, i) => {
          const indicators = [...c.indicators].sort(t => t.kind === 'severe-warning' ? -1 : 1);

          return (
            <IndicatorAssetGroupDiv key={i}>
              <DataQualityDetailAsset
                assetName={c.assetName}
                assetType={c.assetType}
                assetUrl={linksDisabled ? null : c.assetUrl}
                remoteType={c.remoteType}
              />
              <IndicatorIndicatorsGroupDiv>
                <RenderIndicators linksDisabled={linksDisabled ?? false} assetName={c.assetName} indicators={indicators} keyIndex={`${i}`} />
              </IndicatorIndicatorsGroupDiv>
            </IndicatorAssetGroupDiv>)
        })
      }
    </IndicatorAssetChildGroupDiv>
  );
}

/**
 * @deprecated TFS-1478812
*/
export function RenderAssetsIndicators(props: RenderIndicatorsProps): JSX.Element | null {
  const shouldRenderTopSection = props.indicators.length > 0 || props.childrenIndicatorAndAsset.length > 0;
  const shouldRenderBottomSection = props.upstream.length > 0;
  const shouldRenderTopBottomSpacer = shouldRenderTopSection && shouldRenderBottomSection;

  if (!shouldRenderTopSection && !shouldRenderBottomSection) {
    return null
  }

  return (
    <>
      {
        shouldRenderTopSection && <RenderAnchoredAssetsIndicators {...props} />
      }
      {
        shouldRenderTopBottomSpacer && <BigSpacer />
      }
      {
        shouldRenderBottomSection &&
        <>
          <IndicatorGroupHeadingDiv>
            {upstreamOfThisAssetMessage(props.subjectArea)}
          </IndicatorGroupHeadingDiv>
          <IndicatorAssetGroupDiv>
            {props.upstream.map((value, i) =>
              <React.Fragment key={i}>
                <DataQualityDetailAsset
                  assetName={value.assetName}
                  assetType={value.assetType}
                  assetUrl={props.linksDisabled ? null : value.assetUrl}
                  remoteType={value.remoteType}
                />
                <IndicatorIndicatorsGroupDiv>
                  <RenderIndicators linksDisabled={props.linksDisabled ?? false} assetName={value.assetName} indicators={value.indicators} keyIndex={`${i}`} />
                </IndicatorIndicatorsGroupDiv>
              </React.Fragment>
            )}
          </IndicatorAssetGroupDiv>
        </>
      }
    </>
  );
}
